import React from 'react';
import { Link } from 'react-router-dom';
import { GlassCard } from '../shared/GlassCard';
import { GradientText } from '../shared/GradientText';
import { FadeIn, StaggerContainer, StaggerItem } from '../shared/MotionWrapper';
import { getAllGames, saveLastGameId, isGamePlayEnabled } from '../../data/games';

function GamesShowcaseSection() {
  const games = getAllGames();

  const handlePlayNow = (gameId) => {
    saveLastGameId(gameId);
  };

  return (
    <section className="relative py-24">
      <div className="absolute inset-0 bg-gradient-to-b from-dark to-dark-secondary" />
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: 'url(/images/background-games.jpg)',
          opacity: 0.25,
        }}
      />
      <div className="absolute inset-0 particle-bg opacity-50" />

      <div className="container-premium relative z-10">
        <FadeIn className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-4">
            The <GradientText variant="hash" className="text-3xl sm:text-4xl lg:text-5xl font-bold">Five</GradientText>{' '}
            <GradientText variant="medora" className="text-3xl sm:text-4xl lg:text-5xl font-bold">Games</GradientText>
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            From entry-level quick wins to elite-tier moonshots — a game for every player
          </p>
        </FadeIn>

        <StaggerContainer className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4">
          {games.map((game) => (
            <StaggerItem key={game.id}>
              <GlassCard
                variant={game.color === 'gold' ? 'gold' : 'blue'}
                className="p-5 flex flex-col h-full relative overflow-hidden"
              >
                {/* Background game icon */}
                <img
                  src={game.icon}
                  alt=""
                  className="absolute inset-0 w-full h-full object-contain opacity-10 pointer-events-none"
                  aria-hidden="true"
                />
                <div className="flex items-center justify-between mb-4">
                  <img
                    src={game.icon}
                    alt={game.name}
                    className="w-14 h-14 sm:w-20 sm:h-20 md:w-24 md:h-24 object-contain"
                  />
                  <span className="text-3xl font-bold text-gray-700">
                    {game.tierNumber}
                  </span>
                </div>

                <div className="mb-1">
                  <img
                    src={game.textImage}
                    alt={game.shortName}
                    className="h-6 sm:h-7 md:h-8 w-auto object-contain"
                  />
                </div>
                <p className="text-gray-500 text-xs mb-4">{game.tier}</p>

                <div className="space-y-2 mb-4 flex-1">
                  <div className="flex justify-between text-sm">
                    <span className="text-gray-400">Max Prize</span>
                    <span className="text-hash-gold font-bold">
                      {game.maxPrize.toLocaleString()} USD
                    </span>
                  </div>
                  <div className="flex justify-between text-sm">
                    <span className="text-gray-400">Win Rate</span>
                    <span className="text-medora-blue font-bold">
                      {(game.totalWinProbability * 100).toFixed(game.tierNumber >= 4 ? 2 : 1)}%
                    </span>
                  </div>
                  <div className="flex justify-between text-sm">
                    <span className="text-gray-400">Entry</span>
                    <span className="text-white font-bold">{game.entryFee} USD</span>
                  </div>
                </div>

                {isGamePlayEnabled(game.id) ? (
                  <Link
                    to="/games"
                    onClick={() => handlePlayNow(game.id)}
                    className="w-full py-2.5 px-4 rounded-lg bg-gradient-to-r from-hash-gold/20 to-medora-blue/20 border border-hash-gold/30 text-hash-gold text-sm font-semibold text-center hover:bg-hash-gold/10 transition-colors"
                  >
                    Play Now
                  </Link>
                ) : (
                  <span
                    className="w-full py-2.5 px-4 rounded-lg border border-gray-600/40 bg-gray-800/50 text-gray-500 text-sm font-semibold text-center cursor-not-allowed"
                    title="Not open for play yet"
                  >
                    Coming soon
                  </span>
                )}
              </GlassCard>
            </StaggerItem>
          ))}
        </StaggerContainer>
      </div>
    </section>
  );
}

export default GamesShowcaseSection;
